export const EventNames = {
  loginChange: 'login-change',
  miniProgramDetected: 'mini-program-detected',
  getDeviceToken: 'get_device_token'
}
